"use client";
import React from "react";

import Header from "@components/common/Header";
import Footer from "@components/common/Footer";
import Content from "@components/Post/Content";
import Intro from "@components/Post/Intro";
import Details from "@components/Post/Details";

import getter from "@services/StrapiService/getter";
import { map } from "lodash";
import { MY_CODE_PEN } from "@utils/validate";
import Script from "next/script";
import Head from "next/head";
import { usePageContext } from "@providers/PageProvider";
const NAVS = [
  // {
  //   title: "about",
  //   link: "/about",
  // },
  {
    title: "my cv",
    link: "https://ehphuong.page.link/cv",
    target: "_blank",
  },
];
export default function View(props: any) {
  const { pageData } = usePageContext();
  const details = getter.details(pageData);
  // const hasCodePen = MY_CODE_PEN.test(get(post, "content", ""));
  const hasCodePen = React.useMemo(() => {
    let result = false;
    map(details, (item) => {
      if (!result) {
        result = MY_CODE_PEN.test(item.content || "");
      }
    });
    return result;
  }, [details.length]);
  const version = (Math.random() * 1000).toFixed(0);
  return (
    <>
      {!!hasCodePen && (
        <Script
          type="text/javascript"
          // strategy="beforeInteractive"
          src={`https://cpwebassets.codepen.io/assets/embed/ei.js?version=${version}`}
        />
      )}
      <main data-scroll-container className="article">
        <Header page={props.page} NAVS={NAVS} distance={true} />
        <Content />
        <Footer />
      </main>
    </>
  );
}
